import i18n, { normalizeLanguage } from "./index";

const activeLanguage = () => normalizeLanguage(i18n.resolvedLanguage || "en");

export const formatNumber = (
  value: number,
  options?: Intl.NumberFormatOptions
): string => {
  return new Intl.NumberFormat(activeLanguage(), options).format(value);
};

export const formatCompactNumber = (value: number): string => {
  return new Intl.NumberFormat(activeLanguage(), {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);
};

export const formatPercent = (value: number): string => {
  return new Intl.NumberFormat(activeLanguage(), {
    style: "percent",
    maximumFractionDigits: 2,
  }).format(value);
};
